<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/invoice-apply/approve/table">开票管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <span slot="header">开票申请 - 抵扣-财务审批</span>
      <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px">
        <div class="medium"
             style="width: auto">
          <!-- 开票详情 -->
          <InvoiceApplyInfo :form="form"/>

          <!-- 开票发票列表 -->
          <InvoiceDetailsList :form="form"/>

          <!-- 开票状态 -->
          <InvoiceStatusLayout :form="form"/>

          <!--待作废及之后状态都可看到红冲相关-->
          <InvoiceReturnLayout v-if="form.status > 7"
                               :form="form"/>
        </div>

      </el-form>
    </layout-panel>

    <!--   抵扣详情panel，可以进行审批   -->
    <layout-panel v-if="form.deduction_detail.length > 0">
      <span slot="header">抵扣详情</span>
      <InvoiceDeductLayout :form="form"/>
    </layout-panel>
    </template>

  </div>
</template>

<script>
import InvoiceApplyInfo from '../../components/InvoiceApplyInfo'
import InvoiceDetailsList from '../../components/InvoiceDetailsList'
import InvoiceStatusLayout from '../../components/InvoiceStatusLayout'
import InvoiceReturnLayout from '../../components/InvoiceReturnLayout'
import InvoiceDeductLayout from '../../components/InvoiceDeductLayout'
import ErrorPanel from '@components/ErrorPanel.vue'

export default {
  components: {
    ErrorPanel,
    InvoiceApplyInfo,
    InvoiceDetailsList,
    InvoiceStatusLayout,
    InvoiceReturnLayout,
    InvoiceDeductLayout,
  },
  data () {
    return {
      showErrorMsg: true,
      detailErrorMsg: '',
      form: {
        deduction_detail: [],
        attached_file: [],
        log: [],
        cc: [],
        red_flush_attached_file: [],
        detail: [],
        received_details: [],
        split_list: [],
      },
    }
  },
  async created () {
    this.setForm(this.$route.params.id)
  },
  watch: {},
  computed: {
    ...Vuex.mapState({}),
  },
  methods: {
    ...Vuex.mapActions([]),
    setForm (id) {
      request('getInvoiceApplyDetail', {id, forFinance: 1}).then(({data}) => {
        this.form = data
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/pages/approve/InvoiceDeductFinReview.vue